export default "__VITE_ASSET__CoW$jFpV__"